import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '@frontend-site/shared/data';
import { RequestStatusInfo } from '../models/request-status';

@Injectable()
export class RequestStatusFetcherService {
    constructor(private readonly http: HttpClient, @Inject(API_URL) private readonly apiUrl: string) {}

    getRequestStatus(projectId: number): Observable<RequestStatusInfo[]> {
        const params = new HttpParams().set('projectId', projectId);
        return this.http.get<RequestStatusInfo[]>(`${this.apiUrl}/tmCommon/longRequests`, { params });
    }
}
